import './App.css';
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  useLocation
} from 'react-router-dom';

import { useEffect, useState } from 'react';

import Home from './components/website/Home';
import About from './components/website/About';
import Batchschedule from './components/website/Batchschedule';
import EnquiryForm from './components/website/EnquiryForm';
import Recruiters from './components/website/Recruiters';
import Java from './components/website/Java';
import Ourcoursespage from './components/website/Ourcoursespage';
import Contact from './components/website/Contact';
import SuccessStories from './components/website/SuccessStories';
import BlogList from './components/website/BlogList';
import BlogDetail from './components/website/BlogDetail';
import CourseDetails from './components/website/CourseDetails';
import TermsAndConditions from './components/website/TermsAndConditions';
import PrivacyPolicies from './components/website/PrivacyPolicies';
import RefundPolicy from './components/website/RefundPolicy';
import ProfanityPolicy from './components/website/ProfanityPolicy';
import { Quickinfo } from './components/website/Quickinfo';
import All_Courses from './components/website/All_Courses';
import { Free_Placement_Calls } from './components/website/Free_Placement_Calls';

import AdminHome from './components/admin/AdminHome';
import AddBlog from './components/admin/AddBlog';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminEnquiries from './components/admin/AdminEnquiries';
import AdminPlacementcalls from './components/admin/AdminPlacementcalls';
import AdminUpcomingBatches from './components/admin/AdminUpcomingBatches';
import AdminSuccessStories from './components/admin/AdminSuccessStories';
import AdminBlogs from './components/admin/AdminBlogs';
import AdminRecruiters from './components/admin/AdminRecruiters';
import AdminBatchSchedule from './components/admin/AdminBatchSchedule';
import AdminUsers from './components/admin/AdminUsers';
import AdminDemoEnquiries from './components/admin/AdminDemoEnquiries';

import You_could_be_the_next_one from './components/website/You_could_be_the_next_one';
import Layout from './components/website/Layout';
import Frontpopup_form from './components/website/Frontpopup_form';
import { PopupProvider } from './components/website/PopupContext';
import Careers from './components/website/Careers';

import ScrollToTop from './components/website/ScrollToTop';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



// ✅ Wrapper to conditionally render popup inside the Router context
const LayoutWithPopup = () => {
  const location = useLocation();
  const path = location.pathname;

  // ✅ Don't show popup on this page or any /admin route
  const shouldShowPopup = path !== '/you_could_be_the_next_one' && !path.startsWith('/admin');

  return (
    <>
    <ScrollToTop />
      <Outlet />
      {shouldShowPopup && <Frontpopup_form />}
    </>
  );
};

const router = createBrowserRouter([
  {
    element: <LayoutWithPopup />, // use wrapper with Outlet and popup
    children: [
      { path: '/', element: <Home /> },
      { path: '/batchschedule', element: <Batchschedule /> },
      { path: '/enquiryform', element: <EnquiryForm /> },
      { path: '/recruiters', element: <Recruiters /> },
      { path: '/Full-Stack-Java-Development', element: <Java /> },
      { path: '/courses', element: <Ourcoursespage /> },
      { path: '/About-Us', element: <About /> },
      { path: '/Contact', element: <Contact /> },
      { path: '/Success-Stories', element: <SuccessStories /> },
      { path: '/Blog', element: <BlogList /> },
      { path: '/blogdetails/:slug', element: <BlogDetail /> },
      { path: '/course-details/:slug', element: <CourseDetails /> },
      { path: '/TermsAndConditions', element: <TermsAndConditions /> },
      { path: '/PrivacyPolicies', element: <PrivacyPolicies /> },
      { path: '/RefundPolicy', element: <RefundPolicy /> },
      { path: '/ProfanityPolicy', element: <ProfanityPolicy /> },
      { path: '/quickinfo', element: <Quickinfo /> },
      { path: '/course/:slug', element: <All_Courses /> },
      { path: '/Free-Placement-Calls', element: <Free_Placement_Calls /> },
      { path: '/you_could_be_the_next_one', element: <You_could_be_the_next_one /> },
      { path: '/careers', element: <Careers /> },

      // Admin
      { path: '/admin', element: <AdminHome /> },
      { path: '/admin/addblog', element: <AddBlog /> },
      { path: '/admin/dashboard', element: <AdminDashboard /> },
      { path: '/admin/enquiries', element: <AdminEnquiries /> },
      { path: '/admin/placementcalls', element: <AdminPlacementcalls /> },
      { path: '/admin/upcomingbatches', element: <AdminUpcomingBatches /> },
      { path: '/admin/successstories', element: <AdminSuccessStories /> },
      { path: '/admin/blogs', element: <AdminBlogs /> },
      { path: '/admin/recruiters', element: <AdminRecruiters /> },
      { path: '/admin/batchschedule', element: <AdminBatchSchedule /> },
      { path: '/admin/users', element: <AdminUsers /> },
      { path: '/admin/demoenquiries', element: <AdminDemoEnquiries /> }
    ]
  }
]);

function App() {
  return (
    <div className="App">
      <PopupProvider>
        <RouterProvider router={router} />
      </PopupProvider>
    </div>
  );
}

export default App;
